<template>
  <div>
    <!-- 顶部 -->
    <layout />
    <el-carousel :height="computeHeight">
      <el-carousel-item v-for="(item, index) in sliders" :key="index">
        <img :src="item.img" class="slider_img" />
      </el-carousel-item>
    </el-carousel>
    <div class="solve head-label">
      <div style="text-align: center" class="font_size_24">一站式解决方案</div>
    </div>
    <!-- 盒子 -->
    <div class="border_parent">
      <el-row :gutter="10">
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="images[1].img" class="img_border" />
            </div>
            <div class="border_title">{{ images[1].title }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="images[2].img" class="img_border" />
            </div>
            <div class="border_title">{{ images[2].title }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border">
            <div class="border_img_parent">
              <img :src="images[3].img" class="img_border" />
            </div>
            <div class="border_title">{{ images[3].title }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="6">
          <div class="border" style="margin-right: 0">
            <div class="border_img_parent">
              <img :src="images[4].img" class="img_border" />
            </div>
            <div class="border_title">{{ images[4].title }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 搜索 -->
    <div class="serch">
      <div class="serchInfo">
        <input class="inp" type="text" placeholder="搜索信息..." />
        <span>搜索</span>
      </div>
    </div>
    <!-- 置顶信息 -->
    <div class="border_parent">
      <div class="content">
        <h2 class="con-title">置顶信息</h2>
        <p class="con-de">置顶推荐信息，去发布信息!</p>
        <!-- 信息 -->
        <el-row :gutter="10">
          <router-link
            :to="{
              path: '/detail',
              query: {
                title: item.title,
                text: item.detail[0],
                detail: item.text,
              },
            }"
            v-for="(item, index) in topData"
            :key="index"
          >
            <el-col :xs="24" :sm="10" :md="8">
              <div class="items">
                <div class="f1">
                  <img :src="item.img1" alt="" />
                  <div class="items-info">
                    <h4>{{ item.title }}</h4>
                    <p class="text">
                      {{ item.text }}
                    </p>
                    <p class="detail">
                      <span>{{ item.detail[0] }}</span>
                      <span>{{ item.detail[1] }}</span>
                    </p>
                  </div>
                </div>
                <div class="btn">查看详情</div>
              </div>
            </el-col>
          </router-link>
        </el-row>
      </div>
    </div>
    <!-- 最新信息 -->
    <div class="border_parent">
      <div class="new-data">
        <h4 class="new-data-tit">最新信息</h4>
        <el-row :gutter="10">
          <router-link
            :to="{
              path: '/detail',
              query: {
                title: item.title,
                text: item.detail[0],
                detail: item.text,
              },
            }"
            v-for="(item, index) in newData"
            :key="index"
          >
            <el-col :xs="24" :sm="10" :md="12" style="padding: 0">
              <div class="li">
                <div class="title">
                  <img :src="item.img" alt="" />
                  <h4>{{ item.title }}</h4>
                </div>
                <div class="text">
                  {{ item.text }}
                </div>
                <div class="detail">
                  <span>{{ item.detail[0] }}</span>
                  <span>{{ item.detail[1] }}</span>
                </div>
              </div>
            </el-col>
          </router-link>
        </el-row>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from './footer.vue';
import Layout from './Layout.vue';
export default {
  name: "Index",
  data() {
    return {
      sliders: [],
      images: [
        {
          img: require("../../static/other/用户管理.png"),
          title: "用户管理",
          content: ["用户消费分析", "用户标签设定"],
        },
        {
          img: require("@/assets/diannao.png"),
          title: "二手车",
        },
        {
          img: require("@/assets/dianqi.png"),
          title: "二手闲置",
        },
        {
          img: require("@/assets/shebei.png"),
          title: "房屋出租",
        },
        {
          img: require("@/assets/diandongche.png"),
          title: "生活服务",
        },
      ],
      carousel_height: "550px",
      topData: [
        {
          img1: require("../assets/dianshi.png"),
          title: "小米58寸智能彩电",
          text: "才买的不到二年，ViP到11月份，在保期内一年。带​‌‌有机座，原装遥控器联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["二手闲置", "24-01-04"],
        },
        {
          img1: require("../assets/1.png"),
          title: "单间一房一厅配套出租",
          text: "家具配套齐全，房子靠近路边交通方便采光好，附近有地​‌‌铁，公交站台，菜市场超市等等，欢迎随时都可以过来过来看房子，联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["二手闲置", "24-01-04"],
        },
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/2.png"),
          title: "86平 84万 南北通透",
          text: "房子精装修拎包入住随时看房​‌‌装修情况：精装修联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["房屋出租", "24-01-04"],
        },
      ],
      newData: [
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/dianshi.png"),
          title: "小米58寸智能彩电",
          text: "才买的不到二年，ViP到11月份，在保期内一年。带​‌‌有机座，原装遥控器联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["二手闲置", "01-04"],
        },
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/dianshi.png"),
          title: "单间一房一厅配套出租",
          text: "家具配套齐全，房子靠近路边交通方便采光好，附近有地​‌‌铁，公交站台，菜市场超市等等，欢迎随时都可以过来过来看房子，联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["房屋出租", "01-04"],
        },
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/dianshi.png"),
          title: "86平 84万 南北通透",
          text: "房子精装修拎包入住随时看房​‌‌装修情况：精装修联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["房屋出租", "01-04"],
        },
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/dianshi.png"),
          title: "电梯精装现房 金砖茶城",
          text: "南宁各区域好房源，欢迎进入我的店铺查看，欢迎随时电​‌‌话咨询，相信我的专业，为您置业安家保驾护航。1、小区是成熟小区，入住率高，周边环境配套成熟，地铁口，出行十分方便。2、是电梯小高层，中高楼层，视野非常好。3、学校就在旁边，可落户读书。4、本小区属于政府正规70年产权，城镇住宅性质。。5、来电享受额外优惠。本人全南宁小区都有，随时约。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["房屋出租", "01-04"],
        },
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/dianshi.png"),
          title: "百叶窗-电动百叶窗-遮光百叶窗",
          text: "遮阳-我们是认真的！（同等质量比价格，同等价格比质​‌‌量）南宁天马智能遮阳科技有限公司，成立于2001年，我们以完美的产品质量，完美的售后服务来赢得客户的信任和支持。本公司专业加工批发、销售电动遥控卷帘、电动开台帘、电动天棚帘、电动百叶窗帘、手动卷帘、百叶窗帘、竹木卷帘、推拉帘、百折帘、装饰布帘、隐形纱窗、冬夏门帘。天马拥有专业的成品组装生产线、安装施工团队、及完善的售后服务团队，使我们与各大门窗厂、房地产公司、装饰公司等建立了长期的供货合作关系。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["生活服务", "01-04"],
        },
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/dianshi.png"),
          title: "邕宁年桔，年宵花，草花，绿植租摆",
          text: "遮阳-南宁市香草物语花卉场，专业租摆植物花卉装饰酒店、宾​‌‌馆、办公写字楼、行政机关、购物中心、休闲中心等场所。香草物语坐落于绿城南宁，花卉四季品种多样，种养结合，品种齐全。外地采购品种经本地驯养后再租售，确保了植物的生长状态健康美观。公司与昆明、广州、番禺、深圳、漳州等地的园艺公司及大型花木基地签订长期合作协议，确保采购花卉的品质。经过严格培训的业务人员为您的环境量身定制特色的租摆方案。专业的养护人员定期对花卉进行护理、五星级的养护标准及严格的管理流程为您创造清新干净的办公和家居环境。采用世界优质园艺肥料，澳大利亚澳沃肥料公司生产的巨能神肥水溶性肥料及高级长效控释肥奥绿肥进行养护，无色，无虫，植物生长健康、姿态优美、花叶亮丽。完善的物流配送系统，保证了服务快捷，响应及时。风格各异的盆器、变化多端的艺术组合盆栽，更贴切地融入您的房屋格局、家具及装修风格，使您的办公环境达到更加和谐的艺术美感。规模化的经营确保在同等摆放植物档次情况下，同等价格水平下植物档次高。服务内容：1.出租盆花、盆景、观叶植物，能够提供套盆、套缸、花几、支架、奇石、根雕、水托、仿真花、饰品等园艺附属物品。2.保证所提供的盆栽植株健壮、长势良好并且形态优美、造型优美。3.负责运输，送货上门；租摆到位，定期养护。4.及时更换，保证观赏效果。5.可根据用户要求，进行特殊设计和布置。五、植物租赁服务细则1.植物造形美观，摆放合理，叶色自然。2.清洁卫生，叶面无尘土，无病虫害，盆土无异味。3.及时更换不符合租摆标准的植物。4.园林技工提供“星级”技术跟踪养护服务，每月到场养护4—8次，包括浇水、施肥、虫害防治、保花、保叶、植物更新等工作，园林技工认真负责按植物需要适时进行护理工作，遵守租用方规章制度不得防碍租用方的正常工作与经营。5.定期进行质量服务检查征求租用方意见，及时解决出现问题。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["生活服务", "01-04"],
        },
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/dianshi.png"),
          title: "大众 帕萨特 2011款 1.8TSI 双离合 御尊版",
          text: "遮阳-13年2月帕萨特，1.8T尊荣版，电动座椅，座椅加热，多功能方向盘，定速巡航，天窗，导航，倒车影像，倒车雷达，黑车黑内，本地一手车，12万公里，全车原漆。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌.出租盆花、盆景、观叶植物，能够提供套盆、套缸、花几、支架、奇石、根雕、水托、仿真花、饰品等园艺附属物品。2.保证所提供的盆栽植株健壮、长势良好并且形态优美、造型优美。3.负责运输，送货上门；租摆到位，定期养护。4.及时更换，保证观赏效果。5.可根据用户要求，进行特殊设计和布置。五、植物租赁服务细则1.植物造形美观，摆放合理，叶色自然。2.清洁卫生，叶面无尘土，无病虫害，盆土无异味。3.及时更换不符合租摆标准的植物。4.园林技工提供“星级”技术跟踪养护服务，每月到场养护4—8次，包括浇水、施肥、虫害防治、保花、保叶、植物更新等工作，园林技工认真负责按植物需要适时进行护理工作，遵守租用方规章制度不得防碍租用方的正常工作与经营。5.定期进行质量服务检查征求租用方意见，及时解决出现问题。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["二手车", "01-04"],
        },
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/dianshi.png"),
          title: "丰田 雅力士 2016款 YARiS L 致炫 1.5GS",
          text: "遮阳-13年车子无事故。家里代步的车子，整体表现还可以，省油好开，练手车联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌2月帕萨特，1.8T尊荣版，电动座椅，座椅加热，多功能方向盘，定速巡航，天窗，导航，倒车影像，倒车雷达，黑车黑内，本地一手车，12万公里，全车原漆。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌.出租盆花、盆景、观叶植物，能够提供套盆、套缸、花几、支架、奇石、根雕、水托、仿真花、饰品等园艺附属物品。2.保证所提供的盆栽植株健壮、长势良好并且形态优美、造型优美。3.负责运输，送货上门；租摆到位，定期养护。4.及时更换，保证观赏效果。5.可根据用户要求，进行特殊设计和布置。五、植物租赁服务细则1.植物造形美观，摆放合理，叶色自然。2.清洁卫生，叶面无尘土，无病虫害，盆土无异味。3.及时更换不符合租摆标准的植物。4.园林技工提供“星级”技术跟踪养护服务，每月到场养护4—8次，包括浇水、施肥、虫害防治、保花、保叶、植物更新等工作，园林技工认真负责按植物需要适时进行护理工作，遵守租用方规章制度不得防碍租用方的正常工作与经营。5.定期进行质量服务检查征求租用方意见，及时解决出现问题。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["二手车", "01-04"],
        },
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/dianshi.png"),
          title: "四核i7平时教学做课件的联想笔记本",
          text: "遮阳-联想thinkpad品牌的笔记本电脑，黑色，14寸​‌‌，高清屏，有无线，蓝牙，摄像头，酷睿i7的，硬盘500g，显卡2g，系统是w7的64位系统，我们教学要求统一w7系统，这个可以免费升级w10，配件有笔记本包，鼠标，鼠标垫，保卡，电源，电池，都原装的，说明一下，这个是因为2020年初疫情，学校要求教师必须在家做课件，然后在家给学生上网课，然后学校统一采购的给上课老师发的教学本，用了不到一年，基本做课件，上网课，放投影用的，现在正式开学了，我自己本身有笔记本，这个就很少使用，闲置了，今天想转让给需要的，适合学生学习，办公，设计也可以，这个大型制图，设计没问题，配置主流配置，一年时间，这个保期两年，配件都一起，您拿回去直接可以使用，速度很快，毕竟刚一年，95新以上，诚意可以实际把您需要软件装上，自己用用，合适拿走.诚意转让联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌.8T尊荣版，电动座椅，座椅加热，多功能方向盘，定速巡航，天窗，导航，倒车影像，倒车雷达，黑车黑内，本地一手车，12万公里，全车原漆。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌.出租盆花、盆景、观叶植物，能够提供套盆、套缸、花几、支架、奇石、根雕、水托、仿真花、饰品等园艺附属物品。2.保证所提供的盆栽植株健壮、长势良好并且形态优美、造型优美。3.负责运输，送货上门；租摆到位，定期养护。4.及时更换，保证观赏效果。5.可根据用户要求，进行特殊设计和布置。五、植物租赁服务细则1.植物造形美观，摆放合理，叶色自然。2.清洁卫生，叶面无尘土，无病虫害，盆土无异味。3.及时更换不符合租摆标准的植物。4.园林技工提供“星级”技术跟踪养护服务，每月到场养护4—8次，包括浇水、施肥、虫害防治、保花、保叶、植物更新等工作，园林技工认真负责按植物需要适时进行护理工作，遵守租用方规章制度不得防碍租用方的正常工作与经营。5.定期进行质量服务检查征求租用方意见，及时解决出现问题。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["二手闲置", "01-04"],
        },
        {
          img: require("../assets/ZT2.png"),
          img1: require("../assets/dianshi.png"),
          title: "会议摄影摄像公司",
          text: "遮阳-南宁专业会议摄像照相网络推流照片云直播航拍​‌‌​‌‌无人机产品拍摄视频会议连线课程录制导播切换台视频会议直播宣传片、影视广告片短视频拍摄制作、新闻采访电商视频、大型合影晚会录制高清切换台同学聚会战友聚会跟拍婚礼婚纱服务项目：集体合影、会议摄影、摄像、活动跟拍、年会庆典、宣传片制作、电视广告发行、产品静物拍摄、商务会议、开业庆典、展览促销、拓展活动、生日聚会、高端婚庆婚礼、个人摄影、淘宝产品摄影、广告专题片、宣传片、微电影、商务策划等联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌.诚意转让联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌.8T尊荣版，电动座椅，座椅加热，多功能方向盘，定速巡航，天窗，导航，倒车影像，倒车雷达，黑车黑内，本地一手车，12万公里，全车原漆。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌.出租盆花、盆景、观叶植物，能够提供套盆、套缸、花几、支架、奇石、根雕、水托、仿真花、饰品等园艺附属物品。2.保证所提供的盆栽植株健壮、长势良好并且形态优美、造型优美。3.负责运输，送货上门；租摆到位，定期养护。4.及时更换，保证观赏效果。5.可根据用户要求，进行特殊设计和布置。五、植物租赁服务细则1.植物造形美观，摆放合理，叶色自然。2.清洁卫生，叶面无尘土，无病虫害，盆土无异味。3.及时更换不符合租摆标准的植物。4.园林技工提供“星级”技术跟踪养护服务，每月到场养护4—8次，包括浇水、施肥、虫害防治、保花、保叶、植物更新等工作，园林技工认真负责按植物需要适时进行护理工作，遵守租用方规章制度不得防碍租用方的正常工作与经营。5.定期进行质量服务检查征求租用方意见，及时解决出现问题。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌",
          detail: ["生活服务", "01-04"],
        },
      ],
    };
  },
  components: {
    Layout,
    Footer
  },
  methods: {
    //查看详情
    lockDetail(item) {
      this.$router.push({
        path: "/detail",
        query: {
          title: item.title,
          text: item.detail[0],
          detail: item.text,
        },
      });
    },
  },
  mounted() {
    this.sliders = [
      {
        img: require("../../static/slider/a1.jpg"),
      },
      {
        img: require("../../static/slider/a2.jpg"),
      },
      {
        img: require("../../static/slider/a3.jpg"),
      },
      {
        img: require("../../static/slider/a4.jpg"),
      },
    ];
  },
  computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
    computeArrowImg() {
      let screenHeight = document.body.clientWidth;
      if (screenHeight > 450) {
        return require("../../static/other/arrow.png");
      } else {
        return require("../../static/other/arrow_down.png");
      }
    },
  },
};
</script>
<style scoped lang="less">
.border_parent {
  width: 70%;
  margin: auto;
}

.slider_img {
  height: 550px;
  width: 100%;
}

.solve {
  margin-top: 30px;
  margin-bottom: 10px;
}

.border {
  border-radius: 6px;
  border: 1px solid #ebeef5;
  height: auto;
  margin: 10px;
  padding-bottom: 30px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.border_img_parent {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.product_mobile_content {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.product_mobile_img {
  width: 50%;
}

.border_title {
  font-family: "PingFang SC";
  /* margin-top: 10px; */
  font-size: 1.125em;
  font-weight: bold;
  text-align: center;
}

.img_border {
  /* margin-top: 15px; */
  width: 100px;
  height: 100px;
}

.cooperation {
  margin-top: 30px;
  width: 100%;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
  .slider_img {
    height: 250px;
    width: 100%;
  }

  .border_parent {
    display: flex;
    width: 80%;
    margin: auto;
    height: auto;
    flex-direction: column;
  }

  .border {
    border-radius: 6px;
    border: 1px solid #ebeef5;
    float: left;
    width: 100%;
    height: auto;
    margin: 10px 0 auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    /*background: aquamarine;*/
  }

  .border_img_parent {
    margin-top: 0;
  }

  .head-label {
    display: flex;
    margin-top: 10px;
  }

  .product_spec_parent {
    display: flex;
    width: 90%;
    align-items: center;
    justify-content: center;
    margin: 20px auto;
    height: auto;
    flex-direction: column;
  }

  .border_spec {
    float: left;
    height: auto;
    margin: 8px;
    width: 100%;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .border_title {
    font-family: "PingFang SC";
    margin-top: 5px;
    font-size: 1.125em;
    font-weight: bold;
  }

  .img_border {
    /* margin-top: 8px; */
    width: 100px;
    height: 100px;
  }
}
.font_size_24 {
  font-size: 1.5em;
}
.serch {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 258px;
  margin-top: 50px;
  background-color: #f0f8ff;
  .serchInfo {
    position: absolute;
    top: 50%;
    right: 260px;
    transform: translateY(-50%);
    width: 30%;
    height: 40px;
    display: flex;
    align-items: center;
    border: 1px solid #ced4da;
    border-radius: 8px;
    background-color: #ffffff;
    .inp {
      flex: 1;
      padding-left: 10px;
      border: 0;
      outline: none;
    }
    span {
      cursor: pointer;
      padding-right: 20px;
    }
  }
}
.serch::before {
  content: "";
  background-color: #0099cc;
  border-radius: 50%;
  position: absolute;
  top: -100px;
  left: -30px;
  margin: auto;
  width: 200px;
  height: 200px;
}
.serch::after {
  content: "";
  border: 20px solid #597081;
  border-radius: 50%;
  position: absolute;
  bottom: -140px;
  right: 0;
  left: 0;
  margin: auto;
  width: 150px;
  height: 150px;
}
.content {
  a {
    text-decoration: none;
  }
  .router-link-active {
    text-decoration: none;
  }
  .con-title {
    margin-bottom: 0;
    text-align: center;
    font-size: 46px;
    color: #ff6666;
  }
  .con-de {
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .items {
    overflow: hidden;
    width: 96%;
    margin-top: 20px;
    border-radius: 20px;
    .f1 {
      overflow: hidden;
      height: auto;
      border: 1px solid #ebeef5;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      img {
        width: 100%;
        height: 210px;
      }
      .items-info {
        padding: 0 20px;
        h4 {
          margin-bottom: 0;
          padding-bottom: 10px;
          color: #000000;
        }
        .text {
          margin: 0;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3; /*省略几行写几*/
          -webkit-box-orient: vertical;
          color: #717275;
        }
        .detail {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          color: #717275;
        }
      }
    }
    .btn {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 60px;
      color: #ffffff;
      background: #ff6666;
    }
  }
}
.new-data {
  .new-data-tit {
    font-size: 24px;
    color: #0099cc;
  }
  .li {
    position: relative;
    width: 100%;
    height: 165px;
    border: 1px solid #ddd;
    .title {
      display: flex;
      align-items: center;
      img {
        width: 22px;
        height: 22px;
        margin: 0 20px;
      }
      h4 {
        cursor: pointer;
        margin: 10px 0;
        color: #000000;
      }
    }
    .text {
      padding: 0 20px;
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3; /*省略几行写几*/
      -webkit-box-orient: vertical;
      color: #717275;
    }
    .detail {
      position: absolute;
      bottom: 0px;
      left: 0;
      display: flex;
      padding: 0 20px 10px;
      span {
        padding: 5px 10px;
        margin-right: 5px;
        border-radius: 30px;
        font-size: 12px;
        color: #ffffff;
        background: #ff6666;
      }
    }
  }
}
</style>